import { Accordion, AccordionDetails, AccordionSummary, Button, Stack, Typography } from "@mui/material";
import { useEffect } from "react";
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import index from "../../../api/auth/orders/reservations";
import create from "../../../api/auth/orders/reservations/create";
import useOrderStore from "../../../stores/useOrderStore";
import ReservationForm from "../reservation/ReservationForm";
import { AddCircle } from "@mui/icons-material";
import destroy from "../../../api/auth/orders/reservations/destroy";
import show from "../../../api/auth/orders/show";

export default function OrderReservationForm({ order, afterChange }) {
  const { reservations, setReservations, addReservation, removeReservation, updateOrder } = useOrderStore();

  useEffect(() => {
    show(order.id, (response) => {
      updateOrder(response);
    });
  }, [reservations.length]);

  useEffect(() => {
    index(order.id, (response) => {
      setReservations(response);
    });
  }, []);

  const handleCreate = () => {
    create(order.id, { test: 'value' }, (response) => {
      addReservation(response);
      afterChange && afterChange();
    });
  };

  const handleDelete = (reservation) => {
    destroy(order.id, reservation.id, () => {
      removeReservation(reservation);
      afterChange && afterChange();
    });
  };

  const handleReset = () => {
    reservations.forEach((reservation) => {
      destroy(order.id, reservation.id);
    });
    setTimeout(() => {
      setReservations([]);
      afterChange && afterChange();
    }, 500);
  };

  const isReservationComplete = (reservation) => {
    console.log(reservation.start_date && reservation.end_date && reservation.reservation_items.length > 0);
    return reservation.start_at && reservation.end_at && reservation.reservation_items.length > 0;
  };

  return (
    <Stack>
      <Stack direction="row" my={1} spacing={2}>
        <Button onClick={handleCreate} variant="contained">
          <Stack direction="row" spacing={2}>
            <AddCircle />
            <Typography>Add Reservation</Typography>
          </Stack>
        </Button>
        {reservations.length > 0 && <Button onClick={handleReset} variant="outlined" color="secondary">
          <Typography>
            Clear Reservations
          </Typography>
        </Button>}
      </Stack>
      <Stack gap={1}>
        {reservations.map((reservation) => (
          <Stack key={reservation.id}>
            <Accordion defaultExpanded={!isReservationComplete(reservation) }>
              <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                <Stack direction="row" spacing={2}>
                  <Typography variant="h6">
                    Reservation #{reservation.id}
                  </Typography>
                  <Typography variant="h6" fontWeight={400}>
                    <i>{isReservationComplete(reservation) ? reservation.reservation_items[0]?.item?.item_category?.name : 'Incomplete'}</i>
                  </Typography>
                </Stack>
              </AccordionSummary>
              <AccordionDetails>
              <ReservationForm reservation={reservation} />
                <Stack direction="row" pl={2}>
                  <Button variant="contained" color="error" onClick={() => handleDelete(reservation)}>
                    Remove
                  </Button>
                </Stack>
              </AccordionDetails>
            </Accordion>
          </Stack>
        ))}
      </Stack>
    </Stack>
  );
}